import Duck from 'extensible-duck';
import { cat, event } from 'common/utils/instrumentation';

export default new Duck({
  namespace: 'GEWEB',
  store: 'trackGA',
  types: [
    'EXPRESS_HOMEPAGE_WEB_CLICK',
    'EXPRESS_BOOKINGS_WEB_CLICK',
    'EXPRESS_BOOKINGS_WEB_PAGE_VIEW',
  ],
  reducer: state => state,
  creators: duck => ({
    /// EXPRESS_HOMEPAGE_WEB
    trackGAExpressHomepageWebClick: (name, extra = {}) => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_CLICK,
      event: event.HOMEPAGE_CLICKS,
      category: cat.GE_HOMEPAGE,
      name,
      extra,
    }),

    /// EXPRESS_BOOKINGS_WEB
    trackGAExpressBookingsWebClick: (name, extra = {}) => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_CLICK,
      event: event.BOOKINGS_CLICKS,
      category: cat.GE_BOOKINGS,
      name,
      extra,
    }),
    trackGAExpressBookingsWebPageView: (extra = {}) => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_PAGE_VIEW,
      event: event.BOOKINGS_PV,
      category: cat.GE_BOOKINGS,
      extra,
    }),
  }),
});
